// src/index.js
// Entry point for the React application. Responsible for rendering the root App component
// into the DOM and initializing performance reporting.

import React from "react"; // Required for JSX transformations and React APIs
import ReactDOM from "react-dom/client"; // Modern React DOM rendering API
import "./index.css"; // Global styles
import App from "./App"; // Root App component
import reportWebVitals from "./reportWebVitals"; // Optional performance reporting

// Create a root and render the App component inside React.StrictMode for highlighting potential problems
const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Optional: Measure and report web vitals for performance monitoring
// To log results, pass a function (e.g., reportWebVitals(console.log))
// Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
